import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "../ui/common/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "../ui/common/table";

export interface UsageRecord {
  recipeName: string;
  createdBy: string;
  createdDate: string;
}

interface UsageDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  demoKitName: string;
  usageRecords: UsageRecord[];
  isLoading?: boolean;
}

const UsageDialog = ({
  open,
  onOpenChange,
  demoKitName,
  usageRecords,
  isLoading = false
}: UsageDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="tw-max-w-2xl">
        <DialogHeader>
          <DialogTitle>Demo Kit Usage</DialogTitle>
          <DialogDescription>
            Recipes using demo kit: {demoKitName}
          </DialogDescription>
        </DialogHeader>

        <div className="tw-border tw-border-border tw-rounded-lg tw-overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="tw-bg-primary/5">
                <TableHead className="tw-font-semibold tw-text-primary">Recipe Name</TableHead>
                <TableHead className="tw-font-semibold tw-text-primary">Created By</TableHead>
                <TableHead className="tw-font-semibold tw-text-primary">Created Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={3} className="tw-text-center tw-py-8 tw-text-muted-foreground">
                    Loading usage data...
                  </TableCell>
                </TableRow>
              ) : usageRecords.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} className="tw-text-center tw-py-8 tw-text-muted-foreground">
                    No recipes are currently using this demo kit.
                  </TableCell>
                </TableRow>
              ) : (
                usageRecords.map((record, index) => (
                  <TableRow key={`${record.recipeName}-${index}`}>
                    <TableCell className="tw-font-medium">{record.recipeName}</TableCell>
                    <TableCell>{record.createdBy}</TableCell>
                    <TableCell className="tw-text-muted-foreground">{record.createdDate}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UsageDialog;
